function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: none;\n      }\n\n      .cls-2 {\n        clip-path: url(#clip-path);\n      }\n\n      .cls-3 {\n        fill: #fff;\n      }\n\n      .cls-4 {\n        clip-path: url(#clip-path-2);\n      }\n    "), /*#__PURE__*/React.createElement("clipPath", {
  id: "clip-path"
}, /*#__PURE__*/React.createElement("path", {
  id: "Clip_2",
  "data-name": "Clip 2",
  className: "cls-1",
  d: "M0,0H9.712V10.087H0Z"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "clip-path-2"
}, /*#__PURE__*/React.createElement("path", {
  id: "Clip_5",
  "data-name": "Clip 5",
  className: "cls-1",
  d: "M0,0H35.937V37.321H0Z"
})));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "ic_journee_inactivite-2",
  "data-name": "ic_journee_inactivite"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_3",
  "data-name": "Group 3",
  transform: "translate(36.288 54.913)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Clip_2-2",
  "data-name": "Clip 2",
  className: "cls-1",
  d: "M0,0H9.712V10.087H0Z",
  transform: "translate(0 0)"
}), /*#__PURE__*/React.createElement("g", {
  id: "Group_3-2",
  "data-name": "Group 3",
  className: "cls-2",
  transform: "translate(0 0)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Fill_1",
  "data-name": "Fill 1",
  className: "cls-3",
  d: "M4.857,0A4.8,4.8,0,0,0,1.422,1.477a5.18,5.18,0,0,0,0,7.13,4.8,4.8,0,0,0,3.435,1.481A4.8,4.8,0,0,0,8.29,8.607a5.18,5.18,0,0,0,0-7.13A4.8,4.8,0,0,0,4.857,0"
}))), /*#__PURE__*/React.createElement("g", {
  id: "Group_6",
  "data-name": "Group 6",
  transform: "translate(0 0)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Clip_5-2",
  "data-name": "Clip 5",
  className: "cls-1",
  d: "M0,0H35.937V37.321H0Z"
}), /*#__PURE__*/React.createElement("g", {
  id: "Group_6-2",
  "data-name": "Group 6",
  className: "cls-4"
}, /*#__PURE__*/React.createElement("path", {
  id: "Fill_4",
  "data-name": "Fill 4",
  className: "cls-3",
  d: "M19.358,10.088,1.422,28.711a5.189,5.189,0,0,0-1.052,5.5,4.858,4.858,0,0,0,4.487,3.114H31.082a5.047,5.047,0,0,0,0-10.086h-14.5L34.515,8.611a5.186,5.186,0,0,0,1.052-5.5A4.858,4.858,0,0,0,31.08,0H4.857A4.952,4.952,0,0,0,0,5.044a4.954,4.954,0,0,0,4.857,5.044Z",
  transform: "translate(0)"
}))), /*#__PURE__*/React.createElement("path", {
  id: "Fill_7",
  "data-name": "Fill 7",
  className: "cls-3",
  d: "M.755,1.5A3.959,3.959,0,0,0,.033,4.336,3.882,3.882,0,0,0,1.45,6.866a3.6,3.6,0,0,0,2.724.75A3.7,3.7,0,0,0,6.615,6.145a3.96,3.96,0,0,0,.719-2.829A3.882,3.882,0,0,0,5.921.783a3.619,3.619,0,0,0-2.73-.75A3.681,3.681,0,0,0,.755,1.5Z",
  transform: "translate(27.079 44.203)"
}));

var SvgIcJourneeInactivite = function SvgIcJourneeInactivite(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "ic_journee_inactivite",
    viewBox: "0 0 46 65",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcJourneeInactivite, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/ic_journee_inactivite.0181f77e.svg";
export { ForwardRef as ReactComponent };